import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=e51e5146&scoped=true&"
import script from "./CustomTable.vue?vue&type=script&lang=js&"
export * from "./CustomTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51e5146",
  null
  
)

export default component.exports